<script lang="ts">
  import type { IconName } from "./blog-types";

  export let name: IconName;
  export let size = 24;
  export let css = "";
</script>

<div class={css}>
  {#if name === "linkedin"}
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 50"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      stroke-width="1"
      fill="currentColor"
    >
      <path
        d="M41,4H9C6.24,4,4,6.24,4,9v32c0,2.76,2.24,5,5,5h32c2.76,0,5-2.24,5-5V9C46,6.24,43.76,4,41,4z M17,20v19h-6V20H17z M11,14.47c0-1.4,1.2-2.47,3-2.47s2.93,1.07,3,2.47c0,1.4-1.12,2.53-3,2.53C12.2,17,11,15.87,11,14.47z M39,39h-6c0,0,0-9.26,0-10 c0-2-1-4-3.5-4.04h-0.08C27,24.96,26,27.02,26,29c0,0.91,0,10,0,10h-6V20h6v2.56c0,0,1.93-2.56,5.81-2.56 c3.97,0,7.19,2.73,7.19,8.26V39z"
      ></path>
    </svg>
  {/if}

  {#if name === "discord"}
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.27 5.33C17.94 4.71 16.5 4.26 15 4C14.85 4.29 14.68 4.69 14.55 5.01C12.98 4.78 11.41 4.78 9.87 5.01C9.74 4.69 9.57 4.29 9.42 4C7.92 4.26 6.48 4.71 5.14 5.33C2.34 9.61 1.56 13.78 1.95 17.89C3.73 19.22 5.46 20.05 7.17 20.61C7.59 20.02 7.97 19.39 8.31 18.74C7.67 18.5 7.05 18.2 6.47 17.85C6.6 17.76 6.73 17.67 6.86 17.57C10.09 19.09 13.54 19.09 16.74 17.57C16.87 17.67 17 17.76 17.13 17.85C16.54 18.2 15.92 18.5 15.28 18.74C15.62 19.39 16 20.02 16.42 20.61C18.13 20.05 19.87 19.22 21.64 17.89C22.1 13.13 20.91 9 19.27 5.33ZM8.57 15.41C7.54 15.41 6.69 14.44 6.69 13.26C6.69 12.08 7.52 11.11 8.57 11.11C9.62 11.11 10.47 12.08 10.45 13.26C10.45 14.44 9.62 15.41 8.57 15.41ZM15.03 15.41C14 15.41 13.15 14.44 13.15 13.26C13.15 12.08 13.98 11.11 15.03 11.11C16.08 11.11 16.93 12.08 16.91 13.26C16.91 14.44 16.08 15.41 15.03 15.41Z"
        fill="currentColor"
      />
    </svg>
  {/if}

  {#if name === "twitter"}
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
        fill="currentColor"
      />
    </svg>
  {/if}

  {#if name === "diagonal-arrow"}
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 17L17 7M17 7H7M17 7V17"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  {/if}

  {#if name === "thumbs-up"}
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 22H4C3.46957 22 2.96086 21.7893 2.58579 21.4142C2.21071 21.0391 2 20.5304 2 20V13C2 12.4696 2.21071 11.9609 2.58579 11.5858C2.96086 11.2107 3.46957 11 4 11H7M14 9V5C14 4.20435 13.6839 3.44129 13.1213 2.87868C12.5587 2.31607 11.7956 2 11 2L7 11V22H18.28C18.7623 22.0055 19.2304 21.8364 19.5979 21.524C19.9654 21.2116 20.2077 20.7769 20.28 20.3L21.66 11.3C21.7035 11.0134 21.6842 10.7207 21.6033 10.4423C21.5225 10.1638 21.3821 9.90629 21.1919 9.68751C21.0016 9.46873 20.7661 9.29393 20.5016 9.17522C20.2371 9.0565 19.9499 8.99672 19.66 9H14Z"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  {/if}

  {#if name === "thumbs-down"}
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 2H20C20.5304 2 21.0391 2.21071 21.4142 2.58579C21.7893 2.96086 22 3.46957 22 4V11C22 11.5304 21.7893 12.0391 21.4142 12.4142C21.0391 12.7893 20.5304 13 20 13H17M10 15V19C10 19.7956 10.3161 20.5587 10.8787 21.1213C11.4413 21.6839 12.2044 22 13 22L17 13V2H5.72C5.23765 1.99446 4.76961 2.16359 4.40205 2.47599C4.03449 2.78839 3.79218 3.22309 3.72 3.7L2.34 12.7C2.29651 12.9866 2.31583 13.2793 2.39666 13.5577C2.47749 13.8362 2.61791 14.0937 2.80815 14.3125C2.99839 14.5313 3.23392 14.7061 3.49843 14.8248C3.76294 14.9435 4.05009 15.0033 4.34 15H10Z"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  {/if}

  {#if name === "arrow-down"}
    <svg width={size} height={size} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 9.47949L12 17.4795L4 9.47949" stroke="currentColor" stroke-width="2" />
    </svg>
  {/if}

  {#if name === "all-blogs"}
    <svg width={size} height={size} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8337 16.313H6.66699C6.20866 16.313 5.8163 16.1498 5.48991 15.8234C5.16352 15.497 5.00033 15.1047 5.00033 14.6463V2.97966C5.00033 2.52132 5.16352 2.12896 5.48991 1.80257C5.8163 1.47618 6.20866 1.31299 6.66699 1.31299H12.5003L17.5003 6.31299V14.6463C17.5003 15.1047 17.3371 15.497 17.0107 15.8234C16.6844 16.1498 16.292 16.313 15.8337 16.313ZM11.667 7.14632V2.97966H6.66699V14.6463H15.8337V7.14632H11.667ZM3.33366 19.6463C2.87533 19.6463 2.48296 19.4831 2.15658 19.1567C1.83019 18.8303 1.66699 18.438 1.66699 17.9797V6.31299H3.33366V17.9797H12.5003V19.6463H3.33366Z"
        fill="currentColor"
      />
    </svg>
  {/if}

  {#if name === "announcements"}
    <svg width={size} height={size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.4997 11.9165V10.0832H20.1663V11.9165H16.4997ZM17.5997 18.3332L14.6663 16.1332L15.7663 14.6665L18.6997 16.8665L17.5997 18.3332ZM15.7663 7.33317L14.6663 5.8665L17.5997 3.6665L18.6997 5.13317L15.7663 7.33317ZM4.58301 17.4165V13.7498H3.66634C3.16217 13.7498 2.73058 13.5703 2.37155 13.2113C2.01252 12.8523 1.83301 12.4207 1.83301 11.9165V10.0832C1.83301 9.579 2.01252 9.14741 2.37155 8.78838C2.73058 8.42935 3.16217 8.24984 3.66634 8.24984H7.33301L11.9163 5.49984V16.4998L7.33301 13.7498H6.41634V17.4165H4.58301ZM10.083 13.2457V8.754L7.83717 10.0832H3.66634V11.9165H7.83717L10.083 13.2457ZM12.833 14.0707V7.929C13.2455 8.29567 13.5778 8.74255 13.8299 9.26963C14.082 9.79671 14.208 10.3734 14.208 10.9998C14.208 11.6262 14.082 12.203 13.8299 12.73C13.5778 13.2571 13.2455 13.704 12.833 14.0707Z"
        fill="currentColor"
      />
    </svg>
  {/if}

  {#if name === "case-studies"}
    <svg width={size} height={size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.33366 16.5002H14.667V14.6668H7.33366V16.5002ZM7.33366 12.8335H14.667V11.0002H7.33366V12.8335ZM5.50033 20.1668C4.99616 20.1668 4.56456 19.9873 4.20553 19.6283C3.84651 19.2693 3.66699 18.8377 3.66699 18.3335V3.66683C3.66699 3.16266 3.84651 2.73107 4.20553 2.37204C4.56456 2.01301 4.99616 1.8335 5.50033 1.8335H12.8337L18.3337 7.3335V18.3335C18.3337 18.8377 18.1541 19.2693 17.7951 19.6283C17.4361 19.9873 17.0045 20.1668 16.5003 20.1668H5.50033ZM11.917 8.25016V3.66683H5.50033V18.3335H16.5003V8.25016H11.917Z"
        fill="#737373"
      />
    </svg>
  {/if}

  {#if name === "how-to-guides"}
    <svg width={size} height={size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.25 17.4167V15.5834H19.25V17.4167H8.25ZM8.25 11.9167V10.0834H19.25V11.9167H8.25ZM8.25 6.41675V4.58341H19.25V6.41675H8.25ZM4.58333 18.3334C4.07917 18.3334 3.64757 18.1539 3.28854 17.7949C2.92951 17.4358 2.75 17.0042 2.75 16.5001C2.75 15.9959 2.92951 15.5643 3.28854 15.2053C3.64757 14.8463 4.07917 14.6667 4.58333 14.6667C5.0875 14.6667 5.5191 14.8463 5.87812 15.2053C6.23715 15.5643 6.41667 15.9959 6.41667 16.5001C6.41667 17.0042 6.23715 17.4358 5.87812 17.7949C5.5191 18.1539 5.0875 18.3334 4.58333 18.3334ZM4.58333 12.8334C4.07917 12.8334 3.64757 12.6539 3.28854 12.2949C2.92951 11.9358 2.75 11.5042 2.75 11.0001C2.75 10.4959 2.92951 10.0643 3.28854 9.70529C3.64757 9.34626 4.07917 9.16675 4.58333 9.16675C5.0875 9.16675 5.5191 9.34626 5.87812 9.70529C6.23715 10.0643 6.41667 10.4959 6.41667 11.0001C6.41667 11.5042 6.23715 11.9358 5.87812 12.2949C5.5191 12.6539 5.0875 12.8334 4.58333 12.8334ZM4.58333 7.33341C4.07917 7.33341 3.64757 7.1539 3.28854 6.79487C2.92951 6.43585 2.75 6.00425 2.75 5.50008C2.75 4.99591 2.92951 4.56432 3.28854 4.20529C3.64757 3.84626 4.07917 3.66675 4.58333 3.66675C5.0875 3.66675 5.5191 3.84626 5.87812 4.20529C6.23715 4.56432 6.41667 4.99591 6.41667 5.50008C6.41667 6.00425 6.23715 6.43585 5.87812 6.79487C5.5191 7.1539 5.0875 7.33341 4.58333 7.33341Z"
        fill="#737373"
      />
    </svg>
  {/if}

  {#if name === "youtube"}
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.543 6.498C22 8.28 22 12 22 12C22 12 22 15.72 21.543 17.502C21.289 18.487 20.546 19.262 19.605 19.524C17.896 20 12 20 12 20C12 20 6.107 20 4.395 19.524C3.45 19.258 2.708 18.484 2.457 17.502C2 15.72 2 12 2 12C2 12 2 8.28 2.457 6.498C2.711 5.513 3.454 4.738 4.395 4.476C6.107 4 12 4 12 4C12 4 17.896 4 19.605 4.476C20.55 4.742 21.292 5.516 21.543 6.498ZM10 15.5L16 12L10 8.5V15.5Z"
        fill="currentColor"
      />
    </svg>
  {/if}
</div>
